import {
    RegulationMapActions,
    RegulationMapState,
    SET_LINK_CONFIRMED,
    SET_CURRENT_BOUNDS,
    TOGGLE_LINK_CLICKABILITY
} from "../../actions/regulation/map/types";

const initialState: RegulationMapState = {
    isLinkClickable: false,
    linkConfirmed: false,
    currentBounds: null
};

const curbManagerMap = (state = initialState, action: RegulationMapActions): RegulationMapState => {
    switch (action.type) {
        case TOGGLE_LINK_CLICKABILITY: {
            return {
                ...state,
                isLinkClickable: action.payload.isLinkClickable
            };
        }
        case SET_LINK_CONFIRMED: {
            return {
                ...state,
                linkConfirmed: action.payload.isLinkConfirmed
            };
        }
        case SET_CURRENT_BOUNDS: {
            return {
                ...state,
                currentBounds: action.payload.currentBounds
            };
        }
        default:
            return {
                ...state
            };
    }
};

export default curbManagerMap;
